module.exports = __webpack_public_path__ + "img/notaire.c38d7584.jpg";